/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {useEffect, useState} from 'react';
import { withTranslation } from 'react-i18next';
import { Grid, Button } from '@material-ui/core';
import TablePagination from '@material-ui/core/TablePagination';
import SearchBar from './equestrianphotoservice/searchBar';
import EventCard from './equestrianphotoservice/eventCard';
import FuseUtils from '../config/FuseUtils';

import { useQuery } from '@apollo/client';
import { GET_ALBUMS } from '../queries';
import { useThemeData } from '../context/ThemeDataContext'
import GeneralText from "../components/Fonts";
/* HOMEPAGE Equestrian photo service*/

function HomeEquestrianPhotoService(props) {
  const {font_family, primary_color_2} = useThemeData().themeData.site.theme;
  const {site_id} = useThemeData().themeData.site;
  const [search] = useState('');
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageInfo, setPageInfo] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [order] = useState({
    order: 'DESC', 
    field: "uitlever_datum"
  });
  

  let albumVariables;
  if (search === '' || search === null) {
    albumVariables = {
      site_id: site_id,
      parent_id: 0,
      page: (page + 1),
      first: rowsPerPage,
      orderBy: [order]
    }
  } else {
    albumVariables = {
      site_id: site_id,
      parent_id: 0,
      page: (page + 1),
      first: rowsPerPage,
      orderBy: [order]
    }
  }

  const { loading: loadingAlbums, error: errorAlbums, data: dataAlbums} =
    useQuery(GET_ALBUMS, {
      variables: albumVariables
    });

    useEffect(() => {
      if (!loadingAlbums && !errorAlbums) {
        if (dataAlbums) {
            if (dataAlbums.albums) {
              async function fetchData() {
                const response = await dataAlbums.albums.data;
                if (response) {
                  setData(dataAlbums.albums.data)
                  setPageInfo(dataAlbums.albums.paginatorInfo)
                }
              }
              fetchData();
            }
        }
      }
    }, [dataAlbums, errorAlbums, loadingAlbums]);

  function handleSearch(e, s) {
    e.preventDefault();
    if (s.length !== 0) {
      //setSearch(search);
      setData(FuseUtils.filterArrayByString(dataAlbums.albums.data, s));
    } else if (s === '' || s === undefined || s === null) {
      ////setSearch(null);
      setData(dataAlbums.albums.data);
    }
  }

  function handleChangePage(event, value) {
    setPage(value);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(event.target.value);
  }

  const goTo = (data) => {
    let location = {
      pathname: `/evenement/${data.folder_id}`,
      state: { data: data }
    }
    props.history.push(location)
  }

  if (loadingAlbums) return <p>{props.t('message:Loading...')}</p>
  if (errorAlbums) return <p>{props.t('Looks like we have a problem...')}</p>

  return (
    <Grid item xs={12} md={12} lg={12} xl={12} className="home" style={{
      fontFamily: `${font_family}`,
      color: `${primary_color_2}`,
    }}>
      <Grid container direction="row">
        <GeneralText
                color={primary_color_2}
                className="top-card"
                variant="h5"
                gutterBottom={true}
              >
                {props.t('Evenementen')}
        </GeneralText>
      </Grid>
      <Grid container direction="row">
        <Grid item sm={6}>
          <GeneralText
                color={primary_color_2}
                className="top-card"
                variant="body1"
                gutterBottom={true}
                style={{
                  textAlign: "left"
                }}
              >
                {props.t('Evenementen omschrijving')}
          </GeneralText>
          </Grid>
        <Grid item sm={6} className="searchBar">
          <SearchBar  handleChange={handleSearch} />
        </Grid>
      </Grid>
      <Grid container direction="row">
        {data.length > 0 && data.map((d) => (
          <Grid item xs={12} sm={6} md={3} lg={3} xl={3} key={d.folder_id}>
            <Button
              className="buttonWidth"
              onClick={() => goTo(d)}
            >
              <EventCard data={d}/>
            </Button>
          </Grid>
        ))}
      </Grid>
      <TablePagination
        className="overflow-hidden flex-shrink-0"
        style={{display: 'flex', justifyContent: 'center'}}
        component="div"
        count={pageInfo.total ? pageInfo.total : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage={props.t('events:Rows per page')}
        backIconButtonProps={{
          'aria-label': 'Previous Page'
        }}
        nextIconButtonProps={{
          'aria-label': 'Next Page'
        }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Grid>
  )

}

export default React.memo(withTranslation(['events', 'message'])(HomeEquestrianPhotoService))

